
    <div class="header-container">
        <div class="pin-icon">
            <i (click) = "closeDialog()" routerLink = "pinnedDialog" routerLinkActive = "active" [ngStyle]="{'cursor':'pointer'}" class="material-icons">push_pin</i>
        </div>
        <div class="header-left-container">
            <h2 mat-dialog-title>Previous Meeting History</h2>
        </div>
        <div class="header-right-container">
            
            <mat-form-field>
                <input type="text" matInput placeholder="search">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
            <div class="close-container">
                <button mat-icon-button mat-dialog-close aria-label="Example icon-button with heart icon" #tooltip="matTooltip"
                matTooltip="close dialog">
                    <mat-icon class = "dialog-close-btn" >close</mat-icon>
                </button>
            </div>
        </div>
    </div>
    <mat-dialog-content class="main-container">    
        <ng-scrollbar [ngStyle]="{'height':'600px'}" #scrollable pointerEventsMethod="scrollbar" [disabled]="disabled">
            <!-- <div > -->
                <cdk-accordion class="example-accordion"> 
                    <cdk-accordion-item
                    #accordionItem="cdkAccordionItem">
                    <div class="example-accordion-item-header" (click)="accordionItem.toggle()">
                        <span class="example-accordion-item-description">
                            <mat-icon class="icon">{{accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
                        </span>
                        <div class="accordion-header-container">
                            <div class="accordion-header-left-container" [ngClass.xl] = "'extra-xl-scr-accordion-header-left-container'">
                                <h2 class="accordion-title">Project Status Meeting</h2>
                                <p>{{currentDate}}. at 2:00 PM for 60 minutes</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <ul class="un-order-list-container" [ngClass.xl] = "'extra-xl-scr-un-order-list-container'" [ngClass.md] = "'md-scr-un-order-list-container'">
                            <li class="list-item">Lakshmi Kala M</li>
                            <li class="list-item">Shivakumar M</li>
                            <li class="list-item">Chandrasekar K</li>
                            <!-- <li class="list-item">3 More..</li> -->
                            <!-- <app-more-participant-previous-meeting-popup></app-more-participant-previous-meeting-popup> -->
                        </ul>
                    </div>
                    <div>
                        <mat-list>
                            <mat-list-item>
                                <div class="list-item-container" [ngClass.xl] = "'extra-xl-list-item-container'" [ngClass.md] = "'md-list-item-container'">
                                    <div>
                                        <h3 class="agenda-name">Agenda - 1:</h3>
                                    </div>
                                    <div>
                                        <h3 class="field">In MOM page, set minimum height for the div which is showing all notes,decision and tasks</h3>
                                        <p class="sub-field">Agora performance meeting </p>
                                    </div>      
                                </div>
                            </mat-list-item>
                        </mat-list>
                    </div>
                    <div
                        class="example-accordion-item-body"
                        role="region"
                        [style.display]="accordionItem.expanded ? '' : 'none'">
                            <div class="accordion-container">
                                <mat-list>
                                    <mat-list-item>
                                        <div class="list-item-container" [ngClass.xs] = "'extra-small-scr-list-item'">
                                            <div class="list-column-one">
                                                <div id = "border-container" class="col" [ngClass.xs] = "'extra-small-scr-list-item'">
                                                    <mat-icon class="drag-indicator-icon list-icon" [ngClass.xs] = "'extra-small-drag-indicator-icon'">drag_indicator</mat-icon>        
                                                </div>
                                                <div class="col" [ngClass.xs] = "'extra-small-scr-col'" contenteditable="true">
                                                    <h4 class="column-content notes-content">Notes</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-list-item>
                                    <mat-divider class="divider-container"></mat-divider>
                                    <mat-list-item>
                                        <div class="list-item-container" [ngClass.xs] = "'extra-small-scr-list-item'">
                                            <div class="list-column-one">
                                                <div id = "border-container" class="col" [ngClass.xs] = "'extra-small-scr-list-item'">
                                                    <mat-icon class="drag-indicator-icon list-icon" [ngClass.xs] = "'extra-small-drag-indicator-icon'">drag_indicator</mat-icon>        
                                                </div>
                                                <div class="col" [ngClass.xs] = "'extra-small-scr-col'" contenteditable="true">
                                                    <h4 class="column-content notes-content">Task</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-list-item>
                                    <mat-divider class="divider-container"></mat-divider>
                                </mat-list>
                            </div>
                    </div>
                    </cdk-accordion-item>
                    <mat-divider class="divider"></mat-divider>
                </cdk-accordion>              
            <!-- </div> -->
        </ng-scrollbar>
    </mat-dialog-content>
    <!-- </ng-scrollbar> -->
<!-- </ng-scrollbar> -->